// The one place the app shows a format's icon or badge (Home posters, the project header, the picker), drawn by the
// brand kit (web/src/brand/FormatBadge.tsx) so every screen uses the same icons and group gels.
// Also: useFormats(), the catalog (GET /api/formats) loaded once per visit.
import { useEffect, useState } from "react";
import { api } from "../api";
import { FormatBadge as BrandBadge, FormatIcon as BrandIcon, FORMAT_BRAND } from "../brand/FormatBadge";
import { formatShort, isFormatId, type FormatId, type FormatInfo } from "../formats";

/** A format's icon (the brand kit's drawing, in its group's gel). */
export function FormatIcon({ format, size = 16 }: { format: string; size?: number }) {
  const f: FormatId = isFormatId(format) ? format : "ad";
  return (
    <span className="cao-fmt fmark-icon" data-group={FORMAT_BRAND[f].group.toLowerCase()}>
      <BrandIcon id={f} size={size} />
    </span>
  );
}

/** "Documentary" with its icon, as a small chip. `overlay`: on top of a picture (a darker, blurred chip). */
export function FormatBadge({ format, overlay = false, className = "" }: { format: string; overlay?: boolean; className?: string }) {
  const f: FormatId = isFormatId(format) ? format : "ad";
  return <BrandBadge id={f} variant="chip" label={formatShort(f)} className={`fbadge${overlay ? " fbadge-overlay" : ""} ${className}`} />;
}

let catalog: Promise<FormatInfo[]> | null = null;
/** The format catalog (GET /api/formats), loaded once; null while loading, [] if it failed. */
export function useFormats(): FormatInfo[] | null {
  const [list, setList] = useState<FormatInfo[] | null>(null);
  useEffect(() => {
    let live = true;
    catalog ??= api.formats().catch((e) => {
      catalog = null;
      throw e;
    });
    catalog.then((f) => live && setList(f)).catch(() => live && setList([]));
    return () => {
      live = false;
    };
  }, []);
  return list;
}
